<template>
  <myhead :value="value" @next="next" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>
  <div class="detail">
    <p class="detail-tle">{{ info.title }}</p>
    <p class="detail-desc">问题简介问题简介</p>
    <p class="detail-result">调研结果:<span>3.双方的责任</span></p>
    <div class="result">
        <div class="result-tle">
            <img src="@/assets/img/icon42.png" class="result-icon">
            <p>调研结果</p>
        </div>
        <div class="result-list" v-for="item in info.options" :key="item.id">
            <p class="result-list-info">{{ item.name }}<span>{{item.vote}}票 / {{ item.ratio_name }}</span></p>
            <van-progress :percentage="item.ratio*100" stroke-width="12" :show-pivot="false" />
        </div>
        <!-- <div class="result-list">
            <p class="result-list-info">A.某某某的责任:…<span>15票 / 30%</span></p>
            <van-progress :percentage="50" stroke-width="12" :show-pivot="false" />
        </div>
        <div class="result-list">
            <p class="result-list-info">A.某某某的责任:…<span>15票 / 30%</span></p>
            <van-progress :percentage="50" stroke-width="12" :show-pivot="false" />
        </div>
        <div class="result-list">
            <p class="result-list-info">A.某某某的责任:…<span>15票 / 30%</span></p>
            <van-progress :percentage="50" stroke-width="12" :show-pivot="false" />
        </div>
        <div class="result-list">
            <p class="result-list-info">A.某某某的责任:…<span>15票 / 30%</span></p>
            <van-progress :percentage="50" stroke-width="12" :show-pivot="false" />
        </div> -->
        <div class="result-look">
            <p>{{ info.end_time }}</p>
            <div><p>{{info.vote_num}}人已投票</p><router-link to="">查看</router-link></div>
        </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import ajax from "@/utils/request";
import {useRoute} from "vue-router";
const route = useRoute();
const { query } = route;

const info = ref([])

ajax.post("forum/getopinionsurvey",{id: query.id}).then(res => {
    info.value = res.data
})
</script>
<style scoped>
    .detail {
        padding: 3.2vw 4vw 0;
    }
    .detail p {
        font-size: 14px;
    }
    .detail-tle {
        color: #666666;
    }
    .detail-desc {
        color: #333333;
        margin-top: 2.4vw;
        margin-bottom: 2.4vw;
    }
    .detail-result {
        color: #333333;
    }
    .detail-result span {
        color: #3F7C93;
    }
    .result {
        margin-top: 5.3333vw;
    }
    .result-tle {
        display: flex;
        align-items: center;
    }
    .result-icon {
        width: 4.8vw;
        margin-right: .5333vw;
    }
    .result-list {
        margin-top: 5.3333vw;
    }
    .result-list-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 3.2vw;
        color: #999999;
    }
    .result-look {
        margin-top: 5.3333vw;
        font-size: 14px;
        color: #999999;
    }
    .result-look, .result-look div {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .result-look a {
        color: #3F7C93;
        margin-left: 2.6667vw;
    }
</style>